// Kept local: the generated `CARD_LINE_2_PATTERN` is the backend's equivalent literal
// (/^[A-Z0-9 ]*$/), but a character CLASS is what a replace needs, and duplicating the
// literal in two forms is how the two drift apart.
const CARD_LINE_2_ALLOWED_CHARS = 'A-Z0-9 ';

/**
 * Coerces free text into what the card's second line accepts: upper case, and only the
 * characters the embosser allows.
 *
 * Lives here, not in `types/apiTypes.ts`, because that file is GENERATED from the backend
 * (`type-utils`). This helper has no backend source, so every regeneration deleted it and
 * broke the build.
 */
export const sanitizeCardLine2 = (value: string): string =>
  value
    .toUpperCase()
    .replace(new RegExp(`[^${CARD_LINE_2_ALLOWED_CHARS}]`, 'g'), '');
